/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./video-manage.vue?vue&type=template&id=47d7f350&scoped=true&"
import script from "./video-manage.vue?vue&type=script&lang=ts&"
export * from "./video-manage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d7f350",
  null
  
)

export default component.exports